import React from 'react'
import { useSelector } from 'react-redux'
import classnames from 'classnames'
import Icons from '~/Common-Objects/UI/Icons/index'
import UpsellChip from '~/Common-Objects/UI/Chips/Upsell.jsx'

export default function CheckboxTile({
    value,
    className,
    children,
    outerStyle,
    requiredTier,
    icon,
    header,
    subheader,
    beta,
    postHogTag,
    ...rest
}) {
    const siteMaster = useSelector((state) => state.siteMaster)
    const colors = siteMaster.colours

    const classes = classnames('checkbox-tile', className)
    const headerStyle = {
        fontWeight: 600,
        fontSize: 14,
        lineHeight: '20px',
        letterSpacing: 0,
        color: 'var(--neutral-950)'
    }

    const contentStyle = {
        fontWeight: 400,
        fontSize: 12,
        lineHeight: '16px',
        letterSpacing: '-0.1px',
        color: 'var(--neutral-700)'
    }

    const dataPh = rest['data-ph'] || postHogTag
    const inputProps = Object.assign({}, rest)
    delete inputProps['data-ph']

    return (
        <div className={classes} style={outerStyle}>
            <input
                type='checkbox'
                id={value}
                value={value}
                className='visually-hidden'
                data-ph={dataPh || undefined}
                {...inputProps}
            />

            <label htmlFor={value}>
                {icon && header && subheader && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        <Icons icon={icon} color='var(--neutral-600)' />
                        <div style={headerStyle}>{header}</div>
                        <div style={contentStyle}>{subheader}</div>
                    </div>
                )}

                {children}

                {!requiredTier && (
                    <Icons
                        className='checkbox-tile__tick'
                        icon={rest.checked ? 'tickCircle' : 'circleThin'}
                        color={rest.checked ? colors.$primary : 'var(--neutral-200)'}
                    />
                )}
                {!!requiredTier && !beta && <UpsellChip>{requiredTier}</UpsellChip>}
                {beta && <UpsellChip>Beta</UpsellChip>}
            </label>
        </div>
    )
}
